<template>
  <tr>
    <td>{{ socio.persona.nombre }}</td>
    <td>{{ socio.persona.apellido }}</td>
    <td>{{ socio.persona.email }}</td>
    <td>{{ socio.persona.celular }}</td>
    <td>{{ socio.es_alumno_mentor_de.nombre }} {{ socio.es_alumno_mentor_de.apellido }}</td>
    <td class="botones_mesa_examen">
      <router-link :to="`/datos-inscripcion-examen/${socio.examenes_inscripcion_id}`" class="boton_mesa_examen boton_mesa_examen_estilo boton_ver_info">Ver Info</router-link>
      <BaseLoader4
        v-if="cargando"
      />
      <div v-else class="contenedor_botones_examen_cargado">
        <router-link :to="`/cargar-resultado-examen/${socio.examenes_inscripcion_id}`" class="boton_mesa_examen boton_cargar_examen boton_ver_info" v-if="mostrarBotonCargarExamen">Cargar Examen</router-link>
        <router-link :to="`/examen-cargado/${socio.examenes_inscripcion_id}`" class="boton_mesa_examen boton_mesa_examen_cargado boton_ver_info" v-if="mostrarMensajeExamenCargado">Examen Cargado</router-link>
      </div>
    </td>
  </tr>
</template>

<script>
import examenService from '../services/examen'
import BaseLoader4 from '../components/BaseLoader4.vue'
export default {
  name: 'AnotadosMesaExamenListaItem',
  components: {
    BaseLoader4
  },
  props: ['socio'],
  data: function () {
    return {
      cargando: false,
      mostrarBotonCargarExamen: true,
      mostrarMensajeExamenCargado: false,
      id: this.socio.examenes_inscripcion_id
    }
  },
  methods: {
    dotsCadaTres (dni) {
      if (dni == null) {
        return null
      }
      const number = dni.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
      return number
    }
  },
  mounted: function () {
    setTimeout(() => {
      console.log('examenes_inscripcion_id' + this.id)
      this.cargando = true
      examenService
        .checkCargaDeExamen(this.id)
        .then(respuesta => {
          console.log(respuesta)
          this.cargando = false
          if (respuesta.success) {
            this.mostrarBotonCargarExamen = false
            this.mostrarMensajeExamenCargado = true
          }
        })
    }, 300)
  }
}
</script>

<style>

</style>
